export default __webpack_public_path__ + "static/media/unity.b857d1e4.svg";